import { JSONSchema7Definition } from 'json-schema';
import _ from 'lodash';
import { TextBlendModeOptions, BorderStyleOptions } from './cssPropertyOptions';

declare module 'json-schema' {
    export interface JSONSchema7 {
        enumNames?: Array<string | number>;
    }
}

export interface StyleSchemaWidgetProperties {
    opacity?: string;
    blendModeStyle?: string;
    backgroundColor?: string;
    borderWidth?: string;
    borderColor?: string;
    borderStyle?: string;
    borderRadius?: string;
    boxShadow?: string;
}

export interface StyleSchemaProperties {
    opacity: string;
    'mix-blend-mode': string;
    'background-color': string;
    'border-width': string;
    'border-color': string;
    'border-style': string;
    'border-radius': string;
    'box-shadow': string;
}

interface Schema {
    [key: string]: JSONSchema7Definition;
}

const schema: Schema = {
    // related css property-> opacity: value;
    opacity: {
        type: 'string',
        title: 'Opacity',
        default: '',
    },
    // related css property-> mix-blend-mode: value;
    blendModeStyle: {
        type: 'string',
        title: 'Blend Mode',
        enum: _.keys(TextBlendModeOptions),
        enumNames: _.values(TextBlendModeOptions),
        default: 'normal',
    },
    // related css property-> background-color: value;
    backgroundColor: {
        type: 'string',
        title: 'Fill',
        default: '',
    },
    // related css property-> border-width: value(All sides) ||
    // border-width: value(top) value(right) value(bottom) value(left);
    borderWidth: {
        type: 'string',
        title: 'Border',
        default: '',
    },
    // related css property-> border-color: value;
    borderColor: {
        type: 'string',
        title: 'Border colour',
        default: '',
    },
    // related css property-> border-style: value;
    borderStyle: {
        type: 'string',
        title: 'Border style',
        enum: _.keys(BorderStyleOptions),
        enumNames: _.values(BorderStyleOptions),
        default: 'unset',
    },
    // related css property-> border-radius: value(All sides) ||
    // border-radius: value(top) value(right) value(bottom) value(left);
    borderRadius: {
        type: 'string',
        title: 'Border radius',
        default: '',
    },
    // related css property-> box-shadow: xValue(unit) yValue(unit) rbga(val, val, val, opacity);
    boxShadow: {
        type: 'string',
        title: 'Box Shadow',
        default: '',
    },
};

const group = {
    Style: [
        'opacity',
        'blendModeStyle',
        'backgroundColor',
        'borderWidth',
        'borderColor',
        'borderStyle',
        'borderRadius',
        'boxShadow',
    ],
};

const uiSchema = {
    opacity: { 'ui:widget': 'Slider' },
    blendModeStyle: { 'ui:widget': 'CustomSelect' },
    backgroundColor: { 'ui:widget': 'ThemeColorPicker' },
    borderWidth: { 'ui:widget': 'BoxModelProperties' },
    borderColor: { 'ui:widget': 'ThemeColorPicker' },
    borderStyle: { 'ui:widget': 'CustomSelect' },
    borderRadius: { 'ui:widget': 'BoxModelProperties' },
    boxShadow: { 'ui:widget': 'Shadow' },
};

export const StyleSchema = {
    schema,
    group,
    uiSchema,
};
